import React from "react";
import PropTypes from "prop-types";

import "./animate.css";
import "./splash.css";
import UnexpectedError from "shared/UnexpectedError";

import { useDispatch } from "react-redux";
import * as authActions from "store/actions/authActions";

import { useTranslation } from "react-i18next";
import { Link } from "react-router";

import useLogo from "hooks/useLogo";

const Splash = ({ errorMessage }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { darkLogo } = useLogo();

  const handleRefresh = () => {
    window.location.reload();
  };
  const handleLogout = () => {
    dispatch(authActions.resetSession());
  };

  return (
    <div className="splash" data-testid="splash">
      {errorMessage ? (
        <div className="d-flex flex-column align-items-center justify-content-center">
          <UnexpectedError errorMessage={errorMessage} />
          <div className="d-flex justify-content-center">
            <button className="btn btn-primary me-2" onClick={handleRefresh}>
              {t("header:buttons.refresh")}
            </button>
            <Link
              to="/logout"
              className="btn btn-primary"
              onClick={handleLogout}
            >
              {t("header:buttons.logout")}
            </Link>
          </div>
        </div>
      ) : (
        <img
          className="splash-logo"
          data-testid="splash-logo"
          src={darkLogo}
          alt="Logo"
        />
      )}
    </div>
  );
};

Splash.propTypes = {
  errorMessage: PropTypes.string
};

export default React.memo(Splash);
